interface WindowWithWebkitMessageHandlers extends Window {
  webkit?: {
    messageHandlers?: {
      simpleHandler?: {
        postMessage?(...args: unknown[]): void;
      };
    };
  };
}

export const iosBridge: DeviceMessageBridge = {
  sendMessage: (...args) =>
    (
      window as WindowWithWebkitMessageHandlers
    ).webkit?.messageHandlers?.simpleHandler?.postMessage?.(...args),
};
